import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import {
    createContext,
    FC,
    RefObject,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
} from "react";
import { ModalsContextV2 } from "contexts";
import { ModalTypes } from "utils/constants";
import { UIStateContext } from "contexts";
import Tablet from "./layouts/tablet/Tablet";
import Default from "./layouts/default/Default";

type Props = {
    layout: "default" | "tablet";
};

type IHeaderContext = {
    onWalletOpen: () => void;
    headerRef: RefObject<HTMLElement | null>;
};

export const HeaderContext = createContext<IHeaderContext>(null as any);

const Header: FC<Props> = ({ layout }) => {
    const { openWalletModal, currentModal, advancedSidebarModalRef } = useContext(ModalsContextV2);
    const { setSiteHeaderHeight } = useContext(UIStateContext);
    const headerRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (headerRef.current?.offsetHeight) {
            setSiteHeaderHeight(headerRef.current?.offsetHeight);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onWalletOpen = useCallback(() => {
        if (currentModal !== ModalTypes.WALLET) {
            openWalletModal();
        }
    }, [currentModal, openWalletModal]);

    const renderLayout = useMemo(() => {
        switch (layout) {
            case "tablet":
                return (
                    advancedSidebarModalRef && (
                        <Tablet advancedSidebarModalRef={advancedSidebarModalRef} />
                    )
                );
            default:
                return <Default />;
        }
    }, [advancedSidebarModalRef, layout]);

    const value = useMemo(() => ({ onWalletOpen, headerRef }), [onWalletOpen]);

    return (
        <ErrorBoundary name={Header.name}>
            <HeaderContext.Provider value={value}>{renderLayout}</HeaderContext.Provider>
        </ErrorBoundary>
    );
};

export default Header;
